// `referralCode` is the inviter's own referral code (resolved server-side at
// invite-creation time, see chess repo's clubs/services/referral_lookup.py)
// -- appending it here means a brand-new signup via this link still counts
// as a referral, via the same `?ref=` capture the referral program's own
// links already use (Application.tsx's on-load query-param capture doesn't
// care which screen the URL is "for"). Omitted entirely when absent (the
// lookup failed/timed out, or this invite predates the feature) -- no
// referral credit for that link, nothing else breaks.
export const inviteUrl = (code: string, referralCode?: string | null) => {
  const base = `https://learn.circlechess.com/clubs/invite/${code}`;
  return referralCode ? `${base}?ref=${referralCode}` : base;
};

export const shareInvite = async (code: string, referralCode?: string | null) => {
  const message = `Join my club on Caissa! ${inviteUrl(code, referralCode)} (link valid 24h)`;
  try {
    await navigator.clipboard.writeText(message);
  } catch (err) {
    alert('Failed to copy invite link to clipboard');
  }
};
